import script from "./pagefooter.vue?vue&type=script&setup=true&lang=js"
export * from "./pagefooter.vue?vue&type=script&setup=true&lang=js"

import "./pagefooter.vue?vue&type=style&index=0&id=5de1b578&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de1b578"]])

export default __exports__